import React from 'react'

const IcUserGrey = (props) => <svg {...props} width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx={12} cy={12} r={12} fill="#959595" />
<path d="M15.7985 16.436V15.436C15.7985 14.9056 15.5877 14.3969 15.2127 14.0218C14.8376 13.6467 14.3289 13.436 13.7985 13.436H9.79846C9.26803 13.436 8.75932 13.6467 8.38425 14.0218C8.00918 14.3969 7.79846 14.9056 7.79846 15.436V16.436" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
<path d="M11.7985 11.436C12.903 11.436 13.7985 10.5406 13.7985 9.43604C13.7985 8.33147 12.903 7.43604 11.7985 7.43604C10.6939 7.43604 9.79846 8.33147 9.79846 9.43604C9.79846 10.5406 10.6939 11.436 11.7985 11.436Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
</svg>

export default IcUserGrey
